import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://sfiwussbjtnnqynrlofm.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNmaXd1c3NianRubnF5bnJsb2ZtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgyNzg1MzcsImV4cCI6MjA4Mzg1NDUzN30.KvLFMKRzTo00si6xc-OAJpVSCMRuJetkTgwX5nEgM7E';

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
})